// Тема приложения — палитра макетов «Аудиопособие Интерактив»
export const theme = {
    colors: {
        brandTeal: '#1a9aaa',
        primary: '#1a9aaa',
        primaryDark: '#157a88',
        secondary: '#5c4a32',
        danger: '#8b2500',
        warning: '#8b6914',
        success: '#3d5c3a',

        ink: '#1a1a1a',
        textPrimary: '#1a1a1a',
        textSecondary: '#3d3428',
        textTertiary: '#5c4f3f',
        textLight: '#4a4035',

        parchment: '#e8dcc8',
        parchmentDark: '#d4c4a8',
        parchmentLight: '#f5ebd6',
        parchmentPaper: '#f0e4c8',

        bgPrimary: 'rgba(245, 235, 214, 0.95)',
        bgSecondary: '#f5ebd6',
        bgTertiary: '#ebe0c4',
        bgLight: '#e8dcc8',
        bgDark: '#d4c4a8',

        tableHeaderBlue: '#b8d4e8',
        tableRowAlt: 'rgba(184, 212, 232, 0.35)',
        playerBar: '#1a1a1a',

        borderLight: 'rgba(60, 45, 30, 0.2)',
        borderMedium: 'rgba(40, 30, 20, 0.35)',
        borderDark: '#3d3428',

        errorBg: '#f5e6e0',
        errorText: '#6b1a0a',
        errorBorder: '#c49a8a',
    },

    spacing: {
        xs: '0.5rem',
        sm: '0.75rem',
        md: '1rem',
        lg: '1.5rem',
        xl: '2rem',
        xxl: '2.5rem',
    },

    borderRadius: {
        sm: '4px',
        md: '6px',
        lg: '8px',
        xl: '12px',
    },

    fontSize: {
        xs: '0.75rem',
        sm: '0.875rem',
        base: '1rem',
        lg: '1.125rem',
        xl: '1.25rem',
        '2xl': '1.5rem',
        '3xl': '1.75rem',
        '4xl': '2rem',
    },

    fontWeight: {
        normal: '400',
        medium: '500',
        semibold: '600',
        bold: '700',
    },

    shadows: {
        sm: '0 2px 6px rgba(60, 40, 20, 0.12)',
        md: '0 4px 14px rgba(60, 40, 20, 0.16)',
        lg: '0 6px 18px rgba(60, 40, 20, 0.18)',
        xl: '0 8px 24px rgba(40, 25, 10, 0.22)',
    },

    transitions: {
        default: '0.2s',
        fast: '0.15s',
    },
};
